import { render, staticRenderFns } from "./BillingProtocols.vue?vue&type=template&id=20b74c0f&scoped=true&"
import script from "./BillingProtocols.vue?vue&type=script&lang=js&"
export * from "./BillingProtocols.vue?vue&type=script&lang=js&"
import style0 from "./BillingProtocols.vue?vue&type=style&index=0&id=20b74c0f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b74c0f",
  null
  
)

export default component.exports